import angular from 'angular'
import licenseCtrl from './licenseCtrl'
import entryPage from './view/license.html'

export default angular
    .module('license', [])
    .config(['$stateProvider', function config($stateProvider) {
            $stateProvider.state(
                'license', {
                    // abstract: true,
                    url: '/license',
                    template:entryPage,
                    controller: 'licenseCtrl',
                    title: 'License导入',
                }
            )
        }

    ])
    .controller('licenseCtrl', licenseCtrl)
    // .controller('licenseOperateCtrl', licenseOperateCtrl)
    .name


// WEBPACK FOOTER //
// ./src/app/main/license/index.js